import { MarketNewsContentEntity, } from "@domains/entities/interfaces/iMarketNews";
import * as moment from "moment";
// import * as moment from "@frameworks/web/node_modules/moment/ts3.1-typings/moment";
var MarketNewsDataMapper = /** @class */ (function () {
    function MarketNewsDataMapper() {
    }
    MarketNewsDataMapper.prototype.mapTo = function (MarketNewsData) {
        var _this = this;
        var entity = new Array();
        MarketNewsData.map(function (item) {
            var time = _this.convertEPochToDate(item.pubDateEpoch);
            var marketNewsContent = new MarketNewsContentEntity(time, item.title, item.imageUrl, item.source);
            entity.push(marketNewsContent);
        });
        return entity;
    };
    MarketNewsDataMapper.prototype.convertEPochToDate = function (epoch) {
        return epoch != null && epoch != ""
            ? moment(new Date(parseInt(epoch) * 1000).toLocaleString()).fromNow()
            : "";
        // return "";
    };
    return MarketNewsDataMapper;
}());
export { MarketNewsDataMapper };
